<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div *ngrxLet="lockedEndpoints$ as lockedEndpoints"
     [ngClass]="{'pay-attention': lockedEndpoints > 0, 'optimal': lockedEndpoints === 0}"
     class="endpoints-locked-wrapper stats-component">
  <app-display-total-value
    title="{{'endpoints-locked.title' | translate}}"
    [total]="lockedEndpoints"
    [routeLink]="lockedEndpointsLink"
    [routeQueryParams]="endpointsTarget"
    [loading]="loading$ | async">
  </app-display-total-value>
</div>
